import { Card, Empty } from "antd";
import Plot from "react-plotly.js";
import React from "react";

const AnalysisDisplay = ({ plotly_figs }) => {
  if (!plotly_figs || !Array.isArray(plotly_figs) || plotly_figs.length === 0) {
    return ;
  }

  return (
    <div className="analysis-display" style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
      {plotly_figs.map((fig, idx) => {
        const figure =
          fig.figure_json?.figure_json
            ? fig.figure_json.figure_json
            : fig.figure_json || fig;

        if (!figure?.data || figure.data.length === 0) {
          return (
            <Empty
              key={idx}
              description="No chart data found or unsupported format"
              style={{ marginBottom: "2rem" }}
            />
          );
        }

        // Chart title from layout or fallback
        const chartTitle =
          figure.layout?.title?.text ||
          `Chart ${idx + 1}`;

        return (
          <Card
            key={idx}
            // title={chartTitle}
            style={{marginTop:'10px'}}
          
         
          >
            <Plot
              data={figure?.data}
              layout={{
                ...figure?.layout,
                autosize: true,
                width: undefined,
                height: 400,
                margin: { t: 60, l: 60, r: 30, b: 60, ...(figure?.layout?.margin || {}) },
                paper_bgcolor: "#fff",
                plot_bgcolor: "#f7f8fa"
              }}
              config={{
                ...figure.config,
                displayModeBar: true,
                responsive: true
              }}
              useResizeHandler
              style={{ width: "100%", height: 400 }}
            />
          </Card>
        );
      })}
    </div>
  );
};

export default AnalysisDisplay;